<div class="stepper-container">
  <div class="header">
    <img
      src="../../../../assets/Logos/zentra_logo-removebg-preview 1.png"
      alt="zentra green logo"
      width="50"
      height="50"
    />
    <h1>Zentra Subscription Configuration</h1>
  </div>
  <hr />

  <mat-horizontal-stepper [linear]="isLinear" #stepper>
    <mat-step [stepControl]="customerInfoGroup">
      <form [formGroup]="customerInfoGroup">
        <ng-template matStepLabel>Customer Information</ng-template>
        <div class="review-card-1">
          <div class="card-header">
            <h3>Subscription Review</h3>
          </div>
          <div class="card-body">
            <!-- Product Name -->
            <div class="card-item">
              <h4>Product Name:</h4>
              <p>
                {{ subscriptionData?.subscriptionData?.product_name || "N/A" }}
              </p>
            </div>

            <!-- Components -->
            <div class="card-item">
              <h4>Components:</h4>
              <ul>
                <li
                  *ngFor="
                    let component of subscriptionData?.subscriptionData
                      ?.components
                  "
                >
                  <p>{{ component.name || "N/A" }}</p>
                  <p class="component-quantity">
                    Qty: {{ component.allocated_quantity || "N/A" }}
                  </p>
                  <ng-container
                    *ngIf="
                      subscriptionData?.subscriptionData?.metafields?.[
                        'number_of_units'
                      ] ||
                      subscriptionData?.subscriptionData?.metafields?.[
                        'number_of_perimeter_amenity'
                      ]
                    "
                  >
                    <p class="component-quantity">
                      Number of Units:
                      {{
                        subscriptionData?.subscriptionData?.metafields?.[
                          'number_of_units'
                        ] || "N/A"
                      }}
                    </p>
                    <p class="component-quantity">
                      Number of Perimeter/Amenity:
                      {{
                        subscriptionData?.subscriptionData?.metafields?.[
                          'number_of_perimeter_amenity'
                        ] || "N/A"
                      }}
                    </p>
                  </ng-container>
                </li>
              </ul>
            </div>

            <!-- Billing Renewal Date -->
            <div class="card-item">
              <h4>Billing Renewal Date:</h4>

              <ng-container *ngIf="!isOneTimeProduct; else oneTimeTpl">
                <p>
                  {{
                    subscriptionData?.subscriptionData?.next_billing_at
                      ? (subscriptionData?.subscriptionData?.next_billing_at
                        | date: "MMMM d, y":"UTC")
                      : "N/A"
                  }}
                </p>
              </ng-container>

              <ng-template #oneTimeTpl>
                <p>Non‑recurring — one time fee</p>
              </ng-template>
            </div>

            <!-- Pre-Tax Price -->
            <div class="card-item">
              <h4>Pre-Tax Price:</h4>
              <p>
                ${{
                  subscriptionData?.subscriptionData?.total_pre_tax_price ||
                    "N/A"
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="price-section">
          <div class="section-header">
            <h3>Property Information</h3>
          </div>
          <div class="siteName">
            <mat-form-field class="full-width">
              <mat-label>Property Name/Site Name</mat-label>
              <input matInput formControlName="property_name" maxlength="100" />
            </mat-form-field>
          </div>
          <div class="address-row">
            <mat-form-field class="address-field">
              <mat-label>Address</mat-label>
              <input
                matInput
                formControlName="property_address"
                (input)="onAddressInput($event)"
                placeholder="Start Typing Address - include city, state, zip for better filtering"
              />
            </mat-form-field>
            <div
              *ngIf="addressSuggestions.length > 0"
              class="suggestions-container"
            >
              <ul>
                <li class="manual-entry" (click)="enterManualAddress()">
                  <mat-icon class="address-icon">edit</mat-icon>Can't find your address? Type it in
                </li>
                <li
                  *ngFor="let suggestion of addressSuggestions"
                  (click)="selectSuggestion(suggestion)"
                >
                  <mat-icon class="address-icon">location_on</mat-icon
                  >{{ suggestion.address.freeformAddress }}
                </li>
              </ul>
            </div>

            <mat-form-field class="city-field">
              <mat-label>City</mat-label>
              <input matInput formControlName="property_city" numeric />

              <mat-error
                *ngIf="
                  customerInfoGroup
                    .get('property_city')
                    ?.hasError('nonAlphabetic')
                "
              >
                City name must contain only letters.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="small-field">
              <mat-label>State</mat-label>
              <mat-select formControlName="property_state">
                <mat-optgroup label="United States">
                  <mat-option
                    *ngFor="let state of usStates"
                    [value]="state.abbreviation"
                  >
                    {{ state.name }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="small-field">
              <mat-label>Zip Code</mat-label>
              <input matInput formControlName="property_zip" />
              <mat-error
                *ngIf="
                  customerInfoGroup
                    .get('property_zip')
                    ?.hasError('invalidZipCode')
                "
                >Invalid ZIP code
              </mat-error>
            </mat-form-field>

            <mat-form-field class="small-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="property_country" [disabled]="true">
                <mat-option value="US">United States</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="prop-manager-info-row">
            <mat-form-field class="full-width">
              <mat-label>Property Manager First Name</mat-label>
              <input matInput formControlName="property_manager_f_name" />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Property Manager Last Name</mat-label>
              <input matInput formControlName="property_manager_l_name" />
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Property Manager Email</mat-label>
              <input matInput formControlName="property_manager_email" />
              <mat-error
                *ngIf="
                  customerInfoGroup
                    .get('property_manager_email')
                    ?.hasError('invalidEmail')
                "
              >
                Invalid Email format.
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Property Manager Phone</mat-label>
              <input
                matInput
                formControlName="property_manager_phone"
                appPhoneFormat
              />

              <mat-error
                *ngIf="
                  customerInfoGroup
                    .get('property_manager_phone')
                    ?.hasError('invalidPhoneNumber')
                "
              >
                Phone number must be 10 digits long, excluding spaces and
                symbols.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="paymentGroup" [completed]="chargifyToken !== ''">
      <div>
        <ng-template matStepLabel>Payment Details</ng-template>
        <div class="price-section">
          <div class="section-header">
            <h3>Payment Information</h3>
          </div>
          <div class="same-as">
            <mat-checkbox
              [(ngModel)]="usePropertyDetails"
              (change)="copyPropertyDetailsToChargify()"
            >
              Billing Details Same as Property Details?
            </mat-checkbox>
          </div>

          <app-chargify-form
            [usePropertyDetails]="usePropertyDetails"
            [firstName]="billingDetailsGroup.get('firstName')?.value"
            [lastName]="billingDetailsGroup.get('lastName')?.value"
            [address]="billingDetailsGroup.get('address')?.value"
            [city]="billingDetailsGroup.get('city')?.value"
            [state]="billingDetailsGroup.get('state')?.value"
            [zip]="billingDetailsGroup.get('zip')?.value"
            [country]="billingDetailsGroup.get('country')?.value"
            (validationSuccess)="onChargifyValidationSuccess()"
            (validationFailure)="onChargifyValidationFailure()"
            (achTermsAcceptedChange)="onAchTermsAcceptedChange($event)"
            (achAgreementComplete)="onAchAgreementComplete($event)"
            (isAchChange)="onPaymentMethodChange($event)"
          ></app-chargify-form>
        </div>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Summary</ng-template>
      <div class="review-section">
        <div class="top-review-section">
          <div class="review-card-t1">
            <div class="card-header-summary">
              <h3>Subscription Details</h3>
              <button
                mat-button
                class="previousStepButton"
                style="visibility: hidden"
              >
                Edit
              </button>
            </div>
            <div class="card-body-t1">
              <div class="card-item-review">
                <h4>Plan Details:</h4>
                <p>
                  {{
                    subscriptionData?.subscriptionData?.product_name || "N/A"
                  }}
                </p>
                <div>
                  <div
                    *ngFor="
                      let component of subscriptionData?.subscriptionData
                        ?.components
                    "
                  >
                    <p>
                      {{ component.name || "N/A" }} - Qty:
                      {{ component.allocated_quantity || "N/A" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="review-card-t2">
            <div class="card-header-summary">
              <h3>Property/Customer Information</h3>
              <button
                mat-button
                class="previousStepButton"
                (click)="goToStep(0)"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <div class="card-item-review">
                <h4>Property Name:</h4>
                <p>
                  {{ customerInfoGroup.get("property_name")?.value || "N/A" }}
                </p>
                <h4>Property Address</h4>
                <p>
                  {{
                    customerInfoGroup.get("property_address")?.value || "N/A"
                  }}
                  <br />
                  {{ customerInfoGroup.get("property_city")?.value || "N/A" }},
                  {{ customerInfoGroup.get("property_state")?.value || "N/A" }}
                  {{ customerInfoGroup.get("property_zip")?.value || "N/A" }}
                  {{
                    customerInfoGroup.get("property_country")?.value || "N/A"
                  }}
                </p>
                <h4>Property Owner Information</h4>
                <p>
                  Name:
                  {{
                    customerInfoGroup.get("property_manager_f_name")?.value ||
                      "N/A"
                  }}
                  {{
                    customerInfoGroup.get("property_manager_l_name")?.value ||
                      "N/A"
                  }}
                </p>
                <p>
                  Email:
                  {{
                    customerInfoGroup.get("property_manager_email")?.value ||
                      "N/A"
                  }}
                </p>
                <p>
                  Phone:
                  {{
                    customerInfoGroup.get("property_manager_phone")?.value ||
                      "N/A"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- bottom section -->
        <div class="bottom-review-section">
          <div class="review-card-b1">
            <div class="card-header-summary">
              <h3>Payment Details</h3>
              <button
                mat-button
                class="previousStepButton"
                (click)="goToStep(1)"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <div class="card-item-review">
                <h4 *ngIf="!isAchSelected()">Payment Type: Credit Card</h4>
                <h4 *ngIf="isAchSelected()">Payment Type: Bank Account</h4>
                <br />
                <p *ngIf="!isAchSelected()">
                  Credit Card information has been entered and validated.
                </p>
                <p *ngIf="isAchSelected()">
                  Bank Account information has been entered and validated.
                </p>
                <p>
                  Please ensure your payment method is correct before proceeding
                  with the purchase.
                </p>
              </div>
            </div>
          </div>

          <div class="review-card-b2">
            <div class="card-header-summary">
              <h3>Important Date</h3>
              <button
                mat-button
                class="previousStepButton"
                style="visibility: hidden"
              >
                Edit
              </button>
            </div>
            <div class="card-body">
              <!-- Product Name -->
              <div class="card-item-review">
                <h4>Billing Renewal Date:</h4>

                <p>
                  {{
                    !isOneTimeProduct
                      ? billingDate
                        ? (billingDate | date: "MMMM d, y":"UTC")
                        : "N/A"
                      : "Non‑recurring — one time fee"
                  }}
                </p>
                <p>
                  *On this date, the billing system will charge the payment
                  method you have on file for the upcoming subscription period.
                </p>

                <ng-template #oneTimeTpl>
                  <p>Non‑recurring — one time fee</p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="review-card-b2">
          <div class="card-header-summary">
            <h3>Payment Summary</h3>
            <button
              mat-button
              class="previousStepButton"
              (click)="onPreviewInvoiceClick()"
            >
              Preview Invoice
            </button>
          </div>

          <div class="bottom-review-section">
            <div class="card-item-total-price">
              <div class="line-item" *ngFor="let item of lineItems">
                <p>{{ item.componentName || item.productName }}</p>
                <p>Amount: ${{ item.amountInCents / 100 | number: "1.2-2" }}</p>
              </div>
              <div class="total-area">
                <p>Subtotal: ${{ subtotal | number: "1.2-2" }}</p>
                <p>Total Tax: ${{ totalTax | number: "1.2-2" }}</p>
                <p>
                  <strong>Total:${{ total | number: "1.2-2" }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="terms-container">
          <mat-checkbox [(ngModel)]="termsAccepted">
            I agree to the
            <a href="https://zentra.co/saas-terms/" target="_blank"
              >Terms and Services</a
            >.
          </mat-checkbox>
        </div>
        <div *ngIf="maxioErrors.length > 0" class="error-section">
          <h4>Errors:</h4>
          <ul>
            <li *ngFor="let error of maxioErrors">{{ error }}</li>
          </ul>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  <div
    class="stepperControls padding s6 all"
    *ngIf="stepper?.selectedIndex !== 3"
  >
    <div
      class="button-container"
      [ngClass]="{ 'two-buttons': (stepper?.selectedIndex ?? 0) > 0 }"
    >
      <button
        mat-button
        class="previousStepButton"
        (click)="goToPreviousStep()"
        [style.visibility]=""
        *ngIf="(stepper?.selectedIndex ?? 0) > 0"
      >
        Previous
      </button>

      <button
        mat-raised-button
        class="nextStepButton"
        (click)="goToNextStep()"
        [disabled]="stepper.selectedIndex === 0 ? !isCurrentStepValid() : false"
        *ngIf="stepper?.selectedIndex !== 2"
      >
        Next
      </button>
    </div>

    <button
      mat-raised-button
      class="nextStepButton"
      [disabled]="
        !termsAccepted || !isCurrentStepValid() || (isAch && !achTermsAccepted)
      "
      *ngIf="stepper?.selectedIndex === 2"
      (click)="purchaseSubscription()"
    >
      Purchase
    </button>
  </div>
</div>
